import {
  Container, Flex, Text,
} from "@mantine/core";
import SignalsContainer from "../../../shared/signals/SignalsContainer";
import useEntityDrawerStore from "../../../store/drawer/entityDrawerStore";
import useWorkspaceStore from "../../../store/workspace/workspaceStore";
import MyAccounts from "./components/MyAccounts";
import { useCurrentUser } from "../../../hooks/QueryHooks";

const HeadquartersPage = () => {
  const workspace = useWorkspaceStore((state) => state.workspace);
  const { openDrawer } = useEntityDrawerStore();
  const currentUser: any = useCurrentUser({
    enabled: !!workspace?.id,
  });
  const handleSelectAccount = (acc: any) => {
    openDrawer({
      id: acc,
      type: "accounts"
    });
  };

  return (
    <Container fluid className="overflow-auto w-full relative h-[calc(100vh-80px)] bg-gray-100 ">
      <Text p={16} pt={20} my={8} c="text.9" size="30" fw={700}>
        {`Hey ${currentUser?.data?.first_name || "User"}! Welcome to your HQ.`}
      </Text>
      <Flex className="w-full self-stretch" gap={12}>
        <div className="w-full transition-all duration-200">
          <MyAccounts
            selectedAccId={undefined}
            onAccountClick={handleSelectAccount}
            workspace={workspace}
          />
          <SignalsContainer
            tableHeight={window.innerHeight - 550}
            navTo="inbox"
            containerClass="!mt-3"
            user={currentUser?.data?.user_id}
            workspace={workspace}
          />
        </div>
      </Flex>
    </Container>
  );
};

export default HeadquartersPage;
